import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import FeaturesService from 'ember-feature-flags/services/features';
import RouterService from '@ember/routing/router-service';
import ApiErrorsService from 'cio/services/api-errors';
import AnalyticsService from 'cio/services/analytics';
import { tracked } from '@glimmer/tracking';
import EnvironmentService from 'cio/services/environment';
import ImportModel from 'cio/models/import';

export default class SetupController extends Controller {
  @service features!: FeaturesService;
  @service apiErrors!: ApiErrorsService;
  @service router!: RouterService;
  @service analytics!: AnalyticsService;
  @service environment!: EnvironmentService;

  declare model: ImportModel;

  setupIndexRouteName = 'imports.import.setup.index';
  queryParams = [
    {
      previousRouteName: { as: 'previous_route' },
    },
  ];

  // We don't actually want to show the param in the URL after transitioning, so
  // we copy the value from previousRouteName to _previousRouteName in
  // setupController
  @tracked previousRouteName: 'people' | 'imports' | 'objects.type' | null = null;
  @tracked _previousRouteName: 'people' | 'imports' | 'objects.type' = 'people';
  @tracked objectTypeId = null;

  @computed('router.currentRouteName')
  get setupIndexRoute() {
    return this.router.currentRouteName === this.setupIndexRouteName;
  }

  @action
  deleteImport() {
    let promise = this.model.destroyRecord();

    this.apiErrors.attach(promise);

    this.analytics.track('import', 'canceled', {
      model: this.model,
      source: this.router.currentRouteName,
    });

    promise
      .then(() =>
        this.router.transitionTo(
          this._previousRouteName,
          this.model.segment?.get('id') ?? this.objectTypeId ?? this.environment.current.id,
        ),
      )
      .catch(() => () => this.model.rollbackAttributes());

    return promise;
  }
}
